import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getFormValues, initialize } from 'redux-form';
import { withRouter } from 'react-router';
import _ from 'lodash';

import * as siteActions from 'State/sites/actions';
import { Filter, Main } from 'Containers';
import { ApiResultMessage, LoadingPage, YesNoDialog } from 'Components';
import FileConfigurations from 'Common/FileConfigurations';
import {
  FileFieldEnum,
  ImportScheduleEnum,
  ImportPreviewFieldEnum,
} from 'Common/FieldEnum';
import { CheckForRequiredFieldMap } from 'Common/FilePreviewHelper';
import { toastError, createToast, toastType } from 'Common/ToastHelper';
import {
  IMPORT_SETTINGS,
  FILE_CONFIGURATIONS_FORM_NAME,
} from 'Common/FormEnum';

import { ImportPreview } from './ImportPreview';
import { ImportSettings } from './ImportSettings';

import { MPWApi } from 'API/MPWApi';
import { columnsOptions, mealStatuses } from './fixtures';
import {
  validateColumnData,
  displayErrors,
  getDefaultMealStatusPrompt,
} from './ImportStudentHelper';
import { ImportStudentEnum } from '../../common/Constants/Enumeration/ImportStudentEnum';
import * as ImportStudentSelectors from './state/selectors';
import * as actions from './state/actions';
import { NUMBER_OF_PREVIEW_ROWS } from './helpers/Constants';

let ImportStudentConfigValues = {};

class ImportStudentsContainer extends Component {
  state = {
    file: '',
    defaultMealStatusValue: 4,
    showDialog: false,
    showDeleteDialog: false,
    importConfirmed: false,
  };

  async componentDidMount() {
    const {
      dispatch,
      importStudentReady,
      initializeMappingData,
      getSites,
      importConfigFormValues,
    } = this.props;

    await getSites();
    if (
      (importConfigFormValues &&
        importConfigFormValues.id !== ImportStudentEnum.Auto) ||
      !importConfigFormValues
    ) {
      MPWApi.importStudentsApi
        .loadAllAPIRequest(dispatch, ImportStudentEnum.Default)
        .then((responses) => {
          importStudentReady();
          initializeMappingData();
        });
    }
  }

  componentWillUnmount() {
    this.props.clearAddedMappingDataAction();
    this.props.clearStudentHeaderAction();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      studentHeader: oldStudentHeader = { Data: [] },
      importConfigFormValues: oldimportConfigFormValues,
    } = prevProps;
    const {
      studentHeader = { Data: [] },
      columnMapping = [],
      importConfigFormValues,
      addColumnMapping,
      importStudentReady,
      dispatch,
      importStudentNotReady,
      initialize,
      importSchedule: importScheduleRes,
      settingsDeleted,
      settingsError,
    } = this.props;
    const { file } = this.state;

    if (settingsDeleted && settingsDeleted !== prevProps.settingsDeleted) {
      createToast(
        toastType.success,
        'Auto import deleted successfully',
        '',
        true
      );
      this.setState({ settingsDeleted: false });
    }

    if (settingsError.length > 0 && settingsError !== prevProps.settingsError) {
      toastError(settingsError);
      this.setState({ settingsError: '' });
    }

    // Checks to add mapping to preview table
    if (
      oldStudentHeader.Data.length !== studentHeader.Data.length &&
      !columnMapping.length
    ) {
      addColumnMapping(studentHeader.Data);
    }

    // Checks to add mapping to preview table if import type has changed
    if (
      oldimportConfigFormValues &&
      importConfigFormValues &&
      oldimportConfigFormValues.id !== importConfigFormValues.id
    ) {
      importStudentNotReady();
      //no need to load schedule on this page, pass default

      if (importConfigFormValues.id !== ImportStudentEnum.Auto) {
        MPWApi.importStudentsApi
          .loadAllAPIRequest(dispatch, ImportStudentEnum.Default)
          .then((responses) => {
            const importStudentConfigRes = responses[6];
            const savedConfig = _.get(
              importStudentConfigRes,
              'data.Data',
              null
            );

            importStudentReady();
            addColumnMapping(this.props.studentHeader.Data);

            if (savedConfig) {
              const {
                Delimiter,
                EnrolledValue,
                FileEncoding,
                FileFormat,
                FileName,
                Id,
                IsFirstRowHeader,
                IsWithdrawNotInFile,
                UseMappedValue,
                WithdrawnValue,
              } = savedConfig;
              const importSchedule = _.get(
                importScheduleRes,
                'Data.Data',
                null
              );

              this.getFilePreview({
                delimiter: Delimiter,
                fileEncoding: FileEncoding,
                file,
                recordCount: NUMBER_OF_PREVIEW_ROWS,
              });

              if (importSchedule) {
                // Update form with saved settings
                initialize(IMPORT_SETTINGS, {
                  [FileFieldEnum.Id]: Id,
                  [FileFieldEnum.MealStatusDropDown]: 4,
                  [ImportScheduleEnum.DaysOfTheWeek]:
                    importSchedule.DaysOfTheWeek,
                  [ImportScheduleEnum.Hour]: importSchedule.Hour,
                  [ImportScheduleEnum.Minute]: importSchedule.Minute,
                  [ImportScheduleEnum.AMorPM]: importSchedule.AMorPM,
                  [FileFieldEnum.HeaderRowRadio]: IsFirstRowHeader,
                  [FileFieldEnum.WithdrawNotInFileRowRadio]:
                    IsWithdrawNotInFile,
                  [FileFieldEnum.FileName]: FileName,
                  [FileFieldEnum.EnrolledValue]: EnrolledValue,
                  [FileFieldEnum.WithdrawnValue]: WithdrawnValue,
                  [FileFieldEnum.UseMappedValue]: UseMappedValue,
                  [FileFieldEnum.FileEncoding]: FileEncoding,
                });
              }
              initialize(FILE_CONFIGURATIONS_FORM_NAME, {
                [FileFieldEnum.FileFormatId]: FileFormat,
                [FileFieldEnum.FileSeparatorRadio]: Delimiter,
                [FileFieldEnum.HeaderRowRadio]: IsFirstRowHeader,
              });
            }
          });
      } else {
        importStudentReady();
      }
    }
  }

  uploadAnotherFile = () => {
    const {
      studentHeader = { Data: [] },
      addColumnMapping,
      clearAddedMappingDataAction,
    } = this.props;

    if (studentHeader.Data.length) {
      addColumnMapping(studentHeader.Data);
    } else {
      clearAddedMappingDataAction();
    }
    this.setState({ file: '' });
  };

  changeDelimiter = (delimiter) => {
    const { importConfigFormValues } = this.props;
    const { file } = this.state;

    this.getFilePreview({
      delimiter,
      file,
      fileEncoding: importConfigFormValues[FileFieldEnum.FileEncoding],
      recordCount: NUMBER_OF_PREVIEW_ROWS,
    });
  };

  postFile = (file) => {
    const { fileConfigFormValues, importConfigFormValues } = this.props;

    this.setState({ file: file });
    this.getFilePreview({
      delimiter: fileConfigFormValues[FileFieldEnum.FileSeparatorRadio],
      fileEncoding: importConfigFormValues[FileFieldEnum.FileEncoding],
      file,
      recordCount: NUMBER_OF_PREVIEW_ROWS,
    });
  };

  updatePreviewData = (value, i) => {
    const { columnMapping, importConfigFormValues, addColumnMapping } =
      this.props;
    const longestLineLength = Math.max(
      this.fileData.map((list) => list.length)
    );
    const [success, columnMappingData, column] = validateColumnData(
      value,
      i,
      columnMapping,
      columnsOptions,
      importConfigFormValues[FileFieldEnum.Id],
      longestLineLength
    );

    if (!success) {
      toastError(`You have already selected the field ${column.text}`);
    }

    addColumnMapping(columnMappingData);

    return success;
  };

  confirmImport = () => {
    this.setState(
      {
        importConfirmed: true,
        showDialog: false,
      },
      () => this.saveConfig('import')
    );
  };

  saveConfig = async (type) => {
    let {
      columnMapping,
      fileConfigFormValues,
      importConfigFormValues,
      finalLanguageMappedValues,
      finalMealMappedValues,
      finalSiteMappedValues,
      gradeMappedValues,
      importStudentsConfig,
      importAction,
      clearPostImportStudentsAction,
      postImportStudentsAction,
    } = this.props;

    let fileValues = fileConfigFormValues;
    let importValues = importConfigFormValues;
    let languageValues = _.map(finalLanguageMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let mealValues = _.map(finalMealMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let siteValues = _.map(finalSiteMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let gradeValues = _.map(gradeMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let delimiterValue = fileValues[FileFieldEnum.FileSeparatorRadio];
    ImportStudentConfigValues = {
      Id: importValues[FileFieldEnum.Id],
      FileFormat: 0,
      Description: importStudentsConfig.Description,
      FileName: importValues[FileFieldEnum.FileName],
      Delimiter: delimiterValue || ',',
      IsFirstRowHeader: importValues[FileFieldEnum.HeaderRowRadio],
      IsWithdrawNotInFile:
        importValues[FileFieldEnum.WithdrawNotInFileRowRadio],
      EnrolledValue: importValues[FileFieldEnum.EnrolledValue],
      WithdrawnValue: importValues[FileFieldEnum.WithdrawnValue],
      ImportTypeId: 0,
      EnrollStatus: importValues.mealStatusDropDown,
      UseMappedValue: importValues[FileFieldEnum.UseMappedValue],
      DC_DefaultCaseType: importStudentsConfig.DC_DefaultCaseType,
      DC_ImportTypeId: importStudentsConfig.DC_ImportTypeId,
      FileEncoding: importValues[FileFieldEnum.FileEncoding],
    };

    let FinalObj = {
      ImportStudentHeader: ImportStudentConfigValues,
      LanguageMapping: languageValues,
      MealsStatusMapping: mealValues,
      SiteMapping: siteValues,
      GradeMapping: gradeValues,
      ImportStudentDetailsList: columnMapping,
    };

    if (
      importValues &&
      importValues[FileFieldEnum.Id] === ImportStudentEnum.Auto
    ) {
      FinalObj = {
        ImportStudentHeader: ImportStudentConfigValues,
        LanguageMapping: languageValues,
        MealsStatusMapping: mealValues,
        SiteMapping: siteValues,
        GradeMapping: gradeValues,
        ImportStudentDetailsList: columnMapping,
        ImportSchedule: {
          Hour: importValues[ImportScheduleEnum.Hour],
          Minute: importValues[ImportScheduleEnum.Minute],
          AMorPM: importValues[ImportScheduleEnum.AMorPM],
          DaysOfTheWeek: importValues[ImportScheduleEnum.DaysOfTheWeek],
        },
      };
    }

    if (type === 'save') {
      postImportStudentsAction(FinalObj);
    }

    //functionalize into a required fields present functions and test
    if (type === 'import') {
      // No file! Display error, stop save func.
      if (this.state.file === '') {
        toastError('File is required');
        return;
      }

      const requiredFieldsCheck = CheckForRequiredFieldMap(columnMapping, [
        'Last Name',
        'First Name',
        'Student Number',
        'Site',
      ]);

      if (!requiredFieldsCheck.success) {
        displayErrors(requiredFieldsCheck);
        return;
      }

      const useMappedValue = importValues[FileFieldEnum.UseMappedValue];

      if (!this.state.importConfirmed && !useMappedValue) {
        this.setState({
          showDialog: true,
        });
        return;
      }

      if (useMappedValue) {
        // Check to see if the mealstatus is already mapped via the import grid.
        const statusIsMapped = columnMapping.find(
          (z) => z.FieldName === 'Meal Status'
        );

        if (statusIsMapped && mealValues.length) {
          await postImportStudentsAction(FinalObj);

          let formData = new FormData();
          formData.append('enrollstatus', importValues.mealStatusDropDown);
          formData.append('import_file', this.state.file);

          if (
            this.props.importResponse &&
            this.props.importResponse.Data.Message ===
              'Configuration saved successfully.'
          ) {
            await importAction(formData);
            clearPostImportStudentsAction();
          }
        } else if (!mealValues.length) {
          toastError('You must set at least one custom map meal status.');
        } else {
          toastError(
            'You must have meal status mapped to a column in your file in order to import status'
          );
        }
      } else {
        await postImportStudentsAction(FinalObj);
        let formData = new FormData();
        formData.append('enrollstatus', importValues.mealStatusDropDown);
        formData.append('import_file', this.state.file);

        if (
          this.props.importResponse &&
          this.props.importResponse.Data.Message ===
            'Configuration saved successfully.'
        ) {
          await importAction(formData);
          clearPostImportStudentsAction();
        }
      }
    }
  };

  getMainProps = (showToolbox) => {
    return showToolbox
      ? {
          toolbox: {
            rightButtons: [
              { content: 'Save', onClick: () => this.saveConfig('save') },
              { content: 'Import', onClick: () => this.saveConfig('import') },
            ],
            shown: true,
          },
        }
      : {};
  };

  onFileEncodingChange = (e, option) => {
    const { fileConfigFormValues } = this.props;
    const { file } = this.state;

    this.getFilePreview({
      delimiter: fileConfigFormValues[FileFieldEnum.FileSeparatorRadio],
      fileEncoding: option,
      file,
      recordCount: NUMBER_OF_PREVIEW_ROWS,
    });
  };

  getFilePreview({ delimiter, fileEncoding, file, recordCount }) {
    const { postImportStudentsFile } = this.props;

    if (file) {
      const formData = new FormData();
      formData.append(ImportPreviewFieldEnum.Delimiter, delimiter);
      formData.append(ImportPreviewFieldEnum.FileEncoding, fileEncoding);
      formData.append(ImportPreviewFieldEnum.ImportFile, file);
      formData.append(ImportPreviewFieldEnum.RecordCount, recordCount);
      postImportStudentsFile(formData);
    }
  }

  get fileData() {
    const { importStudents } = this.props;

    return _.get(importStudents, 'Data', []) || [];
  }

  render() {
    const {
      ready,
      dispatch,
      fileConfigFormValues = {},
      importConfigFormValues,
      importStudentsConfig,
      importStudents = {},
      clearImportStudentsErrors,
      clearImportStudentsData,
      setImportStudentsErrors,
      notificationSystem,
      languages,
      languageDataMapped,
      languageOptions,
      finalMealMappedValues,
      finalLanguageMappedValues,
      mappingData,
      columnMapping,
      importSchedule,
      siteOptions,
      sitesMappedDescriptions,
      sitesMapped,
      gradeOptions,
      gradesMappedDescriptions,
      gradesMapped,
      importSettingsData,
    } = this.props;

    const importStudentsErrors = _.get(importStudents, 'Errors', []) || [];

    const { fileSeparatorRadio = ',' } = fileConfigFormValues;

    let {
      UseMappedValue,
      FileFormat,
      Delimiter,
      IsFirstRowHeader = true,
      FileEncoding,
    } = importStudentsConfig;

    const importTypeId = !importConfigFormValues
      ? ImportStudentEnum.Default
      : importConfigFormValues.id;

    if (!Delimiter) Delimiter = fileSeparatorRadio;

    return (
      <Fragment>
        {!ready && <LoadingPage />}
        <Filter
          title={'Import Students/Adults'}
          style={{ marginBottom: '40px' }}
        />
        <Main
          {...this.getMainProps(importTypeId === ImportStudentEnum.Default)}
        >
          {ready && (
            <ImportSettings
              initialValues={{
                [FileFieldEnum.Id]: importStudentsConfig.Id,
                [FileFieldEnum.WithdrawnValue]:
                  importStudentsConfig.WithdrawnValue,
                [FileFieldEnum.EnrolledValue]:
                  importStudentsConfig.EnrolledValue,
                [FileFieldEnum.UseMappedValue]: UseMappedValue,
                [FileFieldEnum.HeaderRowRadio]:
                  importStudentsConfig.IsFirstRowHeader,
                [FileFieldEnum.WithdrawNotInFileRowRadio]:
                  importStudentsConfig.IsWithdrawNotInFile,
                [FileFieldEnum.FileName]: importStudentsConfig.FileName,
                [FileFieldEnum.MealStatusDropDown]: 4,
                [ImportScheduleEnum.DaysOfTheWeek]:
                  importSchedule.Data.Data.DaysOfTheWeek,
                [ImportScheduleEnum.Hour]: importSchedule.Data.Data.Hour,
                [ImportScheduleEnum.Minute]: importSchedule.Data.Data.Minute,
                [ImportScheduleEnum.AMorPM]: importSchedule.Data.Data.AMorPM,
                [FileFieldEnum.FileEncoding]: FileEncoding,
              }}
              isFirstRowHeader={
                !importConfigFormValues
                  ? fileConfigFormValues && fileConfigFormValues.headerRowRadio
                  : importConfigFormValues.headerRowRadio
              }
              dispatch={dispatch}
              languages={languages}
              languageDataMapped={languageDataMapped}
              languageOptions={languageOptions}
              useMappedValue={_.get(
                importConfigFormValues,
                FileFieldEnum.UseMappedValue,
                false
              )}
              importSettingsData={importSettingsData}
              mappingData={mappingData}
              finalLanguageMappedValues={finalLanguageMappedValues}
              finalMealMappedValues={finalMealMappedValues}
              importTypeId={importTypeId}
              onSubmit={
                importConfigFormValues &&
                importConfigFormValues.id === ImportStudentEnum.Auto
                  ? () => this.saveConfig('save')
                  : () => {}
              }
              siteOptions={siteOptions}
              sitesMappedDescriptions={sitesMappedDescriptions}
              sitesMapped={sitesMapped}
              gradeOptions={gradeOptions}
              gradesMappedDescriptions={gradesMappedDescriptions}
              gradesMapped={gradesMapped}
              onFileEncodingChange={this.onFileEncodingChange}
            />
          )}
          {importTypeId === ImportStudentEnum.Default && (
            <FileConfigurations
              dispatch={dispatch}
              formValues={fileConfigFormValues}
              changeDelimiter={this.changeDelimiter}
              displayDropZone={this.fileData.length === 0}
              handleFilePreview={this.postFile}
              clearImportStudentsErrors={clearImportStudentsErrors}
              setImportStudentsErrors={setImportStudentsErrors}
              initialValues={{
                [FileFieldEnum.FileFormatId]: FileFormat,
                [FileFieldEnum.FileSeparatorRadio]: Delimiter,
                [FileFieldEnum.HeaderRowRadio]: IsFirstRowHeader,
              }}
            />
          )}
          {importTypeId === ImportStudentEnum.Default &&
            !!importStudentsErrors.length && (
              <ApiResultMessage result={importStudents} />
            )}
          {importTypeId === ImportStudentEnum.Default &&
            !!this.fileData.length && (
              <ImportPreview
                dispatch={dispatch}
                fileData={this.fileData}
                updatePreviewData={this.updatePreviewData}
                header={columnMapping}
                notificationSystem={notificationSystem}
                clearImportStudentsData={clearImportStudentsData}
                uploadAnotherFile={this.uploadAnotherFile}
              />
            )}
        </Main>
        <YesNoDialog
          title="Confirm Default Meal Status"
          question={getDefaultMealStatusPrompt(
            importConfigFormValues,
            mealStatuses
          )}
          isSavePrompt={false}
          showDialog={this.state.showDialog}
          yesCallback={this.confirmImport}
          noCallback={() => this.setState({ showDialog: false })}
        />
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  ...actions,
  getSites: siteActions.getSitesAction,
  initialize,
};

const mapStateToProps = (state) => {
  const { ImportStudentState } = state;

  return {
    fileConfigFormValues: getFormValues(FILE_CONFIGURATIONS_FORM_NAME)(state),
    importConfigFormValues: getFormValues('ImportSettings')(state),
    importStudents: ImportStudentState.importStudents,
    importStudentsConfig: ImportStudentState.importStudentsConfiguraton.Data,
    languages: ImportStudentSelectors.getLanguages(state),
    finalLanguageMappedValues: ImportStudentState.newLanguageMappingData,
    finalMealMappedValues: ImportStudentState.newMealMappingData,
    finalSiteMappedValues: ImportStudentState.newSiteMappingData,
    gradeMappedValues: ImportStudentState.gradeMappingData,
    importResponse: ImportStudentState.importResponse,
    studentHeader: ImportStudentState.importStudentHeader,
    ready: ImportStudentState.ready,
    columnMapping: ImportStudentState.columnMapping,
    importSchedule: ImportStudentState.importSchedule,
    siteOptions: ImportStudentSelectors.getSiteOptions(state),
    sitesMappedDescriptions:
      ImportStudentSelectors.getSitesMappedDescriptions(state),
    sitesMapped: ImportStudentSelectors.getSitesMapped(state),
    gradeOptions: ImportStudentSelectors.getGradeOptions(state),
    gradesMappedDescriptions:
      ImportStudentSelectors.getGradesMappedDescriptions(state),
    gradesMapped: ImportStudentSelectors.getGradesMapped(state),
    languageOptions: ImportStudentSelectors.getLanguageOptions(state),
    languageDataMapped: ImportStudentSelectors.getMappedLanguageData(state),
    importSettingsData: ImportStudentState.importSettingsData,
    settingsDeleted: ImportStudentState.settingsDeleted,
    settingsError: ImportStudentState.settingsError,
  };
};

export const ImportStudents = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ImportStudentsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/importstudents/ImportStudents.js